import React from 'react';
import Select from '../../../core/form/Select';
import get from 'lodash/get';
import PropTypes from 'prop-types';

const BillContractSelect = (props) => (
  <Select
    showSearch
    value={get(props.values, 'contract', null)}
    onChange={(value) => props.onChange('contract', value)}
    onSearch={props.onSearch}
    errorText={get(props.errors, 'contract', '')}
    label="Contract Document Number"
    disabled={props.submitting || props.loading || props.disabled}
    loading={props.fetching}
    required={props.required}
    options={props.contracts}
    filterOption={(value, option) => option.props.children.toLowerCase().indexOf(value.toLowerCase()) > -1}
  />
);

BillContractSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  fetching: PropTypes.bool,
  contracts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  required: PropTypes.bool,
};

BillContractSelect.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  loading: false,
  fetching: false,
  required: false,
  disabled: false,
};

export default BillContractSelect;
